export enum InputSize
{
    small,
    normal
}